import React from 'react';
import PropTypes from 'prop-types';
import providerEvents from 'wix-art-store-3rd-party/dist/src/sdk/providerEvents';
import Arrow from '-!svg-react-loader!./arrow.svg';

const ProductsList = props => {
  const { data, onProviderAction } = props;

  return (
    <div
      onClick={e => {
        let node = e.target;
        let attr = null;
        let i = 5;
        do {
          if (node && node.getAttribute) {
            attr = node.getAttribute('data-index');
          }
          i--; // Prevent infinit loop
          node = node.parentNode;
        } while (node && !attr && i !== 0)
        const index = parseInt(attr);
        const item = data[index];
        onProviderAction(providerEvents.mobileItemClicked, item.dataKey);
      }}
      className={'products-list-container'}
    >
      <div className={'table-column image-column'}>
        {data.map((item, index) => {
          return (
            <div data-index={index} className={'table-cell table-image-container'}>
              <img className={'table-image'} src={item.imageSrc} />
            </div>
          );
        })}
      </div>
      <div className={'table-column devider-column'}>{data.map((item, index) => {
        return (
          <div data-index={index} className={'table-cell'} />
        );
        })}
      </div>
      <div className={'table-column title-column'}>{data.map((item, index) => {
          return (
            <div data-index={index} className={'table-cell'}>
              <div>
                <span className={'title'}>{item.title}</span><br/>
                <span className={'description'}>{item.subTitle}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className={'table-column arrow-column'}>{data.map((item, index) => {
          return (
            <div data-index={index} className={'table-cell'}>
              <div className={'arrow-container'}>
                {Arrow({ width: '10', height: '16', viewBox: '0 0 10 16' })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ProductsList.propTypes = {

};

export default ProductsList;



// WEBPACK FOOTER //
// ./components/fullscreen/storeMobileComponents/ProductsList.js